export default "__VITE_ASSET__Dw$QT1Tl__"